var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"figure",style:(_vm.content.styles),attrs:{"data-pb-style":_vm.content.pbStyle},domProps:{"innerHTML":_vm._s(_vm.$dompurify(_vm.renderHTML))}})}
var staticRenderFns = []

export { render, staticRenderFns }